import type { Services } from './contracts';
import type { AdminServices } from './adminContracts';
import type { PlatformServices } from './platformContracts';
import { mockAdminServices } from './mock/admin';
import { mockPlatformServices } from './mock/platform';
import { mockCatalog } from './mock/catalog';
import {
  mockAffiliate, mockAuth, mockCoupons, mockLoyalty, mockMarketing, mockOrders, mockTenant, mockWallet,
} from './mock/account';
import { httpServices } from './http/storefront';
import { httpAdminServices } from './http/admin';
import { httpPlatformServices } from './http/platform';
import { httpSellerServices } from './http/seller';
import { httpWarehouseServices } from './http/warehouse';
import { httpPosServices } from './http/pos';
import { httpB2BServices } from './http/b2b';
import { mockSellerServices } from './mock/seller';
import { mockWarehouseServices } from './mock/warehouse';
import { mockPosServices } from './mock/pos';
import { mockB2BServices } from './mock/b2b';
import type { SellerServices } from './sellerContracts';
import type { WarehouseServices } from './warehouseContracts';
import type { PosServices } from './posContracts';
import type { B2BServices } from './b2bContracts';

/**
 * The one place that decides which implementation backs the UI.
 * Set VITE_USE_API=true to call ecommapi (dev proxy → :4000, prod → nginx /api).
 */
const useApi = String(import.meta.env.VITE_USE_API ?? '').toLowerCase() === 'true'
  || String(import.meta.env.VITE_USE_API ?? '') === '1';

export const services: Services = useApi ? httpServices : {
  tenant: mockTenant,
  catalog: mockCatalog,
  marketing: mockMarketing,
  coupons: mockCoupons,
  auth: mockAuth,
  orders: mockOrders,
  wallet: mockWallet,
  loyalty: mockLoyalty,
  affiliate: mockAffiliate,
};

export const adminServices: AdminServices = useApi ? httpAdminServices : mockAdminServices;
export const platformServices: PlatformServices = useApi ? httpPlatformServices : mockPlatformServices;
export const sellerServices: SellerServices = useApi ? httpSellerServices : mockSellerServices;
export const warehouseServices: WarehouseServices = useApi ? httpWarehouseServices : mockWarehouseServices;
export const posServices: PosServices = useApi ? httpPosServices : mockPosServices;
export const b2bServices: B2BServices = useApi ? httpB2BServices : mockB2BServices;
export const apiMode = useApi;

export { ServiceError } from './contracts';
export type { CouponCheck, Services } from './contracts';
